// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2gVLT","noInteraction":"EventWrapper_noInteraction__2YjYJ"};